interface AnthropicIconProps {
    size?: number;
    color?: string;
    className?: string;
}

const Anthropic = ({ size = 20, color = '#1f1f1f', className = '' }: AnthropicIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={size}
        height={size}
        fill={color}
        role="img"
        className={className}
    >
        <title>Anthropic</title>
        <path
            fillRule="evenodd"
            d="M9.218 2h2.402L16 12.987h-2.402zM4.379 2h2.512l4.38 10.987H8.82l-.895-2.308h-4.58l-.896 2.307H0L4.38 2.001zm2.755 6.64L5.635 4.777 4.137 8.64z"
        />
    </svg>
);

export default Anthropic;
